export default {
  abnormal: " Abnormal",
  AbnormalFlow: " Abnormal Flow",
  accept: " Accept",
  account: " Login Account",
  account_balances: " Account Balance",
  account_name: " Client Account",
  account_type: " Receiving Account Type",
  accountInformation: " Account Information",
  accounting: " Financial Name",
  accounting_amount: " Accounting amount",
  accountNum: " Account",
  AccountOpeningDate: " Account Opening Date",
  active: " Active",
  activeStatus: " Active State",
  actual_amount: " Business Application Amount",
  actual_currency: " Business Application Currency",
  actual_receipt: " Actually Received",
  actual_weight: " Gross Weight",
  actualChargeWeight: " Actual Weight",
  add: " Add ",
  addContract: " Add Contract",
  additional_information: " Additional Information",
  addPath: " Route Management",
  addReceipt: " Add Proof of delivery",
  Address2: " Business License/id Card Address (chinese)",
  addressError: " Wrong address",
  addressError_rate: " Wrong address rate",
  addTo: " Add",
  addUser: " Add User",
  addValueService: " Add Value-added Services",
  after: " Back",
  agent: " Agent Management",
  agent_claim: " Responsible Party Claims",
  agent_logo: " Agency Logo",
  agentFee: " Cod Agency Fee",
  agentName: " Agent Name",
  agentProcessed: " To Be Processed By The Agent",
  agentT: " Acting",
  AgentTrajectory: " Agent Trajectory",
  agentTypes: " Agent Type",
  agree: " Agree",
  air: " Route Management",
  air_agent: " Air Freight Forwarder",
  air_freight: " Air Freight",
  air_price: " Airport Handling Charges",
  air_transport: " Air Transport",
  airFreight: " Air Freight",
  airIncome: " Air Freight Revenue Entry",
  airLine: " Route",
  airlineCompany: " Airline",
  airlineMsg: " Airline Information",
  airManagement: " Air Freight Management",
  airPackingList: " List Of Air Freight China-hong Kong Bills",
  airPackingNew: " New Air Freight China-hong Kong Bill",
  airPerformance: " Air Freight Performance",
  airport: " Destination Airport",
  airport_code: " Airport Code",
  airport_fee: " Guangzhou Airport Fee",
  airport_name: " Airport Name",
  airport_t: " Airport",
  airportCost: " Airport Fee",
  airportManage: " Airport Management",
  airShippingMark: " Airfreight Mark Label",
  airWaybillList: " Air Waybill List",
  airWaybillNumber: " Air Waybill Number",
  AliExpress: " Aliexpress",
  aliexpressCode: " Aliexpress code",
  alipay: " Alipay",
  alipay_name: " Name",
  all: " All",
  allow: " Allow",
  allow_arrive: " Destination",
  allow_depart: " Origin",
  allow_status: " Allowable State",
  alreadConfirm: " Weight Confirmed",
  already_listed_number: " Total qty",
  alreadyPick: " Picked Up",
  amazon: " Amazon easyship list",
  AmazonEasyship: " Amazon Easyship",
  AmazonSelfship: " Amazon Selfship",
  amount: " Bill Amount",
  amount_actual: " Actual",
  amount_receivable: " Amount Receivable",
  amount_refunded: " Amount To Be Refunded",
  analysis: " Aging",
  analysis1: " Analyze",
  analysisDate: " Analysis Date",
  analysisResult: " Result List",
  apod: " Have Been Received",
  appConsignorTime: " Appointment time",
  Appendix: " Appendix",
  application: " Application",
  application_reason: " Reason For Application",
  Application_time: " Application Time",
  Appointment: " Schedule Delivery Time",
  appointment_t: " Appointment Party",
  appointmentDate: " Appointment Date",
  appointmentNumber: " Appointment Number",
  appointmentPieces: " Scheduled Delivery List",
  apportion: " Cost Allocation",
  approval_opinion: " Approval Comments",
  approval_remark: " Approval Notes",
  approval_time: " Processing Time",
  approver: " Approver",
  area: " Area",
  arrears: " Amount Owed",
  arrival_date: " Time Of Arrival At The Port Of Destination",
  arrival_HK: " Arrival",
  arrival_HK_date: " Arrived appoint address time",
  arrival_time: " To Warehouse",
  arrival_time_rate: " To Warehouse Rate",
  arrival_warehouse: " Warehousing Time",
  arrivalTime: " Arrived Time",
  arrive: " Arrive",
  ARRIVE_DATE: " Arrived Time",
  AssistContent: " Collaborative Content",
  assistDepartment: " Department",
  assistOrder: " Collaboration Sheet",
  assistPerson: " Collaborator",
  assistPlatform: " Collaboration Platform",
  audit: " Inspector",
  audit_process: " Review Process",
  audit_time: " Review Time",
  auditOrder: " Audit",
  auth: " Authority Management",
  auto_acquire: " Automatic acquisition",
  AvailableInventory: " Available Stock",
  avatar: " Avatar",
  b2b_audit: " B2b Audit",
  b2b_feright: " B2b Quote",
  b2b_prefix: " Mark Code",
  b2b_remain_ticket: " B2b Remaining Votes",
  B2B_SUBPACKAGE: " B2b Subcontracting",
  b2b_warehouse: " B2b Warehouse Management",
  b2bBill: " B2b Billing",
  b2bClient: " Client",
  b2bDetails: " B2b Shipment Details",
  b2bName: " Billing Name",
  B2bOrderNo: " B2b Order Number",
  b2boutbound_number: " B2b Shipments",
  b2bPackingList: " List of transportation ref no.(B2B)",
  back_warehouse: " Restocking Time Limit",
  back_warehouse_num: " Quantity",
  bag: " bag",
  bagCode: " Bag NO.",
  Bagging: " Bagging",
  bagList: " Bag List",
  bagManagement: " Bag Management",
  bagNum: " Bag NO.",
  bagsNum: " Bags",
  bagTime: " Bagging time",
  balance_amount: " Balance To Be Paid",
  bank: " Bank Name",
  bank1: " Bank Card",
  bank_account: " Depositary Bank",
  bank_accounts: " Bank Account",
  bank_address: " Bank Address",
  bank_code: " Accounts Receivable",
  bank_name: " Beneficiary Bank",
  bankDetails: " Bank Details",
  bankInfo: " Bank Information",
  BankTransfer: " Bank Transfer",
  baoguan: " Customs Declaration Type",
  declareCustoms: "declare at customs",
  barCode: " SKU Barcode",
  barcode_t: " Barcode",
  barPhase: " Interception Phase",
  basic_information: " Basic Information",
  batch: " Batch",
  batch_claim: " Initiate Claims In Batches",
  batchAudit: " Batch Review",
  battery: " Battery",
  beenShip: " Has Been Shipped",
  BeforeManifest: " Dispatch Order Not Created",
  BeforeOverseaOutbound: " Not Scanned 140",
  BeforeOverseaWarehouse: " Out Of Stock",
  BeforePackage: " Not Bagged",
  BeforePackageOutboun: " Bag Not Shipped",
  begin_price: " First Cost",
  belongDepartment: " Department",
  big_weight: " Maximum Weight",
  bigImg: " Big Picture",
  bill: " Small Package Bill",
  bill1: " Bill",
  bill_close_account_issuing: " Billing Amount",
  bill_close_account_issuing_charge: " Service charge",
  bill_close_account_issuing_confirm: " Should Be Withdrawn",
  bill_create: " Generate Refundable Bills",
  bill_name: " Billing Name",
  bill_number: " Account Number",
  bill_proceeds_issuing: " Billing Amount",
  bill_proceeds_issuing_charge: " Service charge",
  bill_proceeds_issuing_confirm: " Amount Received",
  bill_receivable: " Generate Bills Receivable",
  bill_type: " Bill Status",
  billBranch: " Small Packet Bill (branch)",
  Billed: " Billed",
  billFailed: " Billing Failed",
  billFee: " Bill Of Lading Clearance Fee",
  billForecast: " Bill Of Lading Forecast List",
  BillInformation: " Bill Of Lading Information",
  Billing: " Billing",
  billing_price: " Billing Unit Price",
  billing_unit: " Unit Of Charging",
  billingCurrency: " Billing Currency",
  billingMethod: " Billing Method",
  billPackageFee: " Consolidation Fee In Bill Of Lading",
  billSuccess: " Billing Succeeded",
  billWeight: " Bill Of Lading Weight",
  bind: " Bind",
  bindContract: " Contract",
  bindCurrency: " Bound Currency",
  bindDep: " Bind Department",
  bindFreight: " Quote Price",
  bindRole: " Bind Role",
  bindRoles: " Bind Role/department",
  blindFactionSLA: " Blind Sla",
  body: " Main Body",
  booking_number: " Booking Number",
  booking: " Booking",
  bounceBack: " Return Order Re-delivery",
  boxOrder: " PL",
  branch: " Branch & Business Quotation",
  branch_bill: " Branch Office Parcel Bill",
  branch_cod: " Branch Cod Details",
  branch_cod_list: " Branch Cod Receivable",
  branch_cod_refund: " Branch Cod Should Be Refunded",
  branch_finance: " Branch Finance",
  branch_name: " Branch Name",
  branch_shipment: " Branch Package Details",
  branchCuditConfiguration: " Branch Claims Configuration",
  branchOffice: " Branch",
  btn_lis: " Button Group",
  btn_name: " Button Name",
  bubble_weight: " Bubble Weight Method",
  BulkAdd: " Batch Add",
  bulletinBoard: " Bulletin Board",
  bulletinContent: " Announcement Content",
  bulletinExtend: " Announcement Annex",
  bulletinSys: " Release System",
  bulletinTime: " Release Time",
  bulletinTitle: " Announcement Title",
  business: " Business",
  business_license: " Business License",
  businessTypes: " Business Type",
  byCallCenter: " To Be Processed By Call Center",
  byCustomer: " To Be Processed By The Customer",
  byOverseasWarehouse: " To Be Processed By Overseas Warehouse",
  byOverseasWarehouseListed: " To Be Available In Overseas Warehouses",
  byOverseasWarehousePicking: " Waiting For Overseas Warehouse Picking",
  byService: " Waiting For Customer Service",
  c_pod: " The Number Of Days To Sign For The Last Trip",
  cabinet_type: " Cabinet Type",
  cabinetNumber: " Cabinet Number",
  calculation: " Calculate",
  callBack: " Tariff Callback",
  called_times: " Tel No Response Count",
  can: " Can",
  cancel: " Cancel",
  cancel_claim: " Withdraw A Claim",
  canShip: " Can Be Shipped",
  car_rental: " Car Rental",
  cargo_number: " PO ID / PRO",
  cargoNumber: " Goods Number",
  cargoNumber1: "Relevance SL.no",
  carrier_code: " Transportation Channel",
  carrier_number: " Carrier Number",
  case_number: " CTNS",
  caseNumber: " CTNS",
  cashPay: " By Cash",
  category: " Product Item",
  category_name: " Product Item",
  category_t: " Category",
  change_amount: " Amount Of Income And Expenditure",
  changeOrder: " Change Order",
  channel: " Channel Management",
  channel_code: " Channel Code",
  channel_logo: " Channel Logo",
  channel_name: " Channel Name",
  channelCost: " Cost Allocation",
  channelCostRate: " Cost Exchange Rate",
  charge: " charge",
  charge_params: " Charge Weight",
  charge_volume: " Charge Volume",
  charged_details: " Battery",
  charging_volume: " Charge Volume",
  check_amount: " Write-off Amount",
  check_amount_currency: " Write-off Currency",
  check_bill_number: " Cod Bill Number",
  check_time: " Write-off Time",
  check_weight: " Inbound weight",
  checkFile: " Select The File",
  checkFreight: " Verify",
  child: " Child",
  china: " China",
  Chinese: " Chinese",
  city: " City Management",
  city_code: " City Code",
  city_mapping: " City Map",
  city_name: " City Name",
  city_t: " City",
  claim: " Claim",
  claim_acceptance: " Accept Claims",
  claim_agree: " Claims Accepted",
  claim_application: " Initiate A Claim",
  claim_fee: " Claim Bill",
  claim_list: " Claims List",
  claim_list_branch: " Branch Claims",
  claim_management: " Claims Management",
  claim_pay: " Pay",
  claim_pool: " Claims Pool",
  claim_standard: " Shipping + Declared Value",
  claim_t: " declare",
  claim_weight: " Declared Weight",
  clearagent: " Customs Clearance Agent",
  clearance: " Customs Clearance",
  clearance_agent: " Customs Name",
  clearance_agent1: " Customs Clearance Agent",
  clearance_agent_params: " Customs Account",
  clearance_date: " Customs Clearance Time",
  clearance_fee_type: " Customs Clearance Fee Type",
  clearance_time: " Customs Clearance",
  clearanceCost: " Customs Clearance Cost",
  clearanceFee: " Clearance Fee",
  client: " Customer Management",
  client_amount: " Customer Application Amount",
  client_currency: " Customer Application Currency",
  clientCompany: " Seller Central",
  clientFreight: " Customer Quotation Review",
  clientInformation: " Customer Information",
  clientName: " Client Account",
  clientDisplay: " Client Display",
  close: " Closure",
  cnName: " Chinese Name",
  cod: " Cod Shipment Details",
  cod_1_time: " Order Time",
  cod_9_time: " Settlement Time",
  cod_agent_rate: " Receipt Exchange Rate",
  cod_amount: " Collection Amount",
  cod_amount_ratio: " Cod Amount Ratio",
  cod_assign: " Client/agent Name",
  cod_bank_fee: " Cod Bank Charges",
  cod_client_rate: " Settlement Exchange Rate",
  cod_collection: " Cod Collection",
  cod_currency: " Cod Currency",
  cod_details: " Billing Details",
  cod_money_back: " Cod Refund",
  cod_ncnd: " Collection",
  cod_ncnd_1_time: " Order Time",
  cod_ncnd_9_time: " Collection Time",
  cod_ncnd_status: " Payment Status",
  cod_number: " Total Votes",
  cod_settlement: " Cod Settlement",
  cod_status: " Billing Status",
  cod_type: " Collection Type",
  cod_type_txt: " Cod Type",
  codAbnormal: " Cod Exception",
  codAmount: " Cod Amount",
  code: " Code",
  code_rules: " Verify",
  codList: " Cod Bills Receivable",
  codNAme: " Billing Name",
  codRate: " Cod Exchange Rate",
  codRefund: " Cod Should Be Refunded",
  codRefundRate: " Cod Should Be Refunded Exchange Rate",
  codTypes: " Bill Type",
  coll: " COD",
  collapse: " Retract",
  collection: " Charge",
  collection_t: " Collection",
  CollectionUser: " Collection User",
  combinedEnquiry: " Co-package Query",
  commodityValue: " Declared Value",
  company: " Service Item",
  company1: " Service Type",
  company_name: " Company Name",
  company_t: " Company",
  complete: " Finish",
  completed: " Completed",
  configuration: " Configure",
  configuration_item: " Configuration Item",
  confirm: " Confirmed",
  confirm_pay: " Confirm Payment",
  confirm_time: " Verify The Time",
  confirmOrder: " Confirm",
  confirmPwd: " Confirm Password",
  confirmWeight: " Confirm The Weight",
  consignor: " Consignee",
  consignorAddress: " Consignee Address",
  consignorPhone: " Consignee Phone",
  contact: " Receiver",
  contactEmail: " Customer Mailbox",
  contain: " Contain",
  content: " Content",
  continueWeight: " Continued Weight Information",
  contraband: " Prohibited item",
  contraband_code: " Coding",
  contraband_description: " Describe",
  contract_account: " Contract Account",
  contract_end_time: " Contract End Date",
  contract_remark: " Contract Notes",
  contract_src: " Contract",
  contract_start_time: " Contract Start Date",
  contract_title: " Preferred Contract Header",
  contract_type: " Agreement",
  contractHeader: " contract header",
  contractInfo: " Contract Information",
  Conversion: " Convert",
  convert: " City Map",
  convert_rate: " Volume Constant",
  ConvertedUdollars: " Converted To Us Dollars",
  cope: " Handle",
  copy: " Copy",
  correctOrderNumber: " Please enter the correct order number",
  correspond: " Correspond",
  cost: " Share The Expense",
  cost_fee: " Cost",
  cost_item_txt: " Secondary Fee",
  cost_share: " Allocated Costs",
  cost_t: " Fees",
  costEntry: " Entry Cost",
  costing: " Finance Costing",
  costName: " Cost Quote Name",
  countdown: " Countdown",
  country: " Country Management",
  country_code_type: " Type",
  country_code_validation: " Rule",
  country_t: " Destination",
  countryCode: " Country Code",
  countryCurrency: " National Currency",
  countryName: " Country",
  countryTimezone: " Country zone",
  countryZone: " Country Code",
  courier: " Dispatcher",
  createBill: " Create Bill",
  createCostBill: " Create Cost Bill",
  createPickup: " Create Pick List",
  createTime: " Create Time",
  createUser: " Creator",
  credit_limit: " Credits",
  creditLimit: " Credits",
  criticalValue: " Median",
  cross_port: " cross port",
  CTNS: " CTNS",
  currency: " Currency Exchange Rate Management",
  currency_t: " Currency",
  currencyCode1: " COD Currency",
  currencyCode: " Currency",
  currencyEnName: " English Name",
  currencyName: " Currency Name",
  currencyType: " Currency Type",
  current_approver: " Current Approver",
  CurrentState: " Current State",
  customer_contract: " Customer Contract",
  customer_group: " Customer Group",
  customer_nums: " Number Of Customers This Month",
  customer_rate: " Follow Up On Increase In Customers",
  customer_report: " Complete Customs Statement",
  customerCompanyName: " Client Company Name",
  customerInt: " Intercept Order List",
  CustomerNote: " customer remark",
  customerProcessed: " To Be Processed By The Customer",
  customerServerBull: " Customer Service Kanban",
  customerWait: " Pending Outbound Confirmation",
  customs_fee: " Customs Fees",
  customsBill: " transportationrefno.",
  CustomsClearer: " Customs Clearer",
  customsFee: " Customs Charges",
  CustomsHold: " Customs Detained",
  Customsinfo: " Customs Information",
  CustomsInspection: " Customs Inspection",
  CustomsReleased: " Domestic Customs Clearance Completed",
  cycle: " cycle",
  danzhengUser: " Documentary",
  data: " Data",
  date: " Date",
  day: " Day",
  dayNumber: " Days",
  dayShipment: " Daily Shipment",
  daysRemaining: " Remaining Days",
  ddp_price: " Ddp Fee",
  ddx: " Tax Collection Method",
  deadline: " Deadline",
  declared_value: " Minimum Declared Value",
  declared_value_rate: " Declared Value Ratio",
  DeclaredValue: " Declared Value",
  safetyServicePlan: "Insurance Plan",
  OriginalDeclaredValue: "Original Declared Value",
  deductExpenses: " deductible expenses",
  delete: " Delete",
  deleteOrder: " Delete Order",
  deliver: " Ship",
  deliver_address: " Delivery Address",
  deliver_goods_number: " Number Of Products Shipped",
  delivery: " Send Warehouse",
  delivery_agent: " Proxy Account",
  delivery_agent_tracker: " Agent Trajectory",
  delivery_method: " transportation way",
  delivery_mode: " Shipping Mode",
  deliveryAddress: " Delivery Address",
  deliveryCompany: " Deliverer",
  deliveryCost: " Delivery Fee",
  deliveryCost_t: " Delivery Fee",
  deliveryCostQuery: " Delivery Fee Inquiry",
  deliveryFee: " Delivery Charges",
  deliveryTime: " Delivery Time",
  DeliveryTimes: " Delivery Times",
  delService: " B2b Customer Service",
  deName: " Department Name",
  deParent: " Superior",
  depart_date: " ATD",
  department: " Organization",
  DEPARTURE_TIME: " Departure Time",
  departureAirport: " Departure Airport",
  dept_date: " Estimated Departure Time",
  dept_HK: " Departure",
  des_goods: " Product name",
  deSc: " Describe",
  destinationAirport: " Destination Airport",
  destinationCountry: " Destination Country",
  destroy: " Destroy",
  destroy_price: " Destruction Fee",
  detail: " Details",
  dingcangCompany: " The carrier company",
  disable: " Disabled",
  disagree: " Disagree",
  discount: " Discount",
  discount_allowance: " Discount",
  distribution_agent: " Delivery Party",
  disWarehouse: " Distribution Warehouse",
  division: " Financial Zoning",
  division_txt: " Financial Zoning",
  doc: " Documentation",
  document_fee: " Data Fee",
  documentClass: " Document Classification",
  documentClassName: " Category Name",
  documentContent: " Document Content",
  documentList: " Document List",
  documentManagement: " Document Management",
  documentName: " File Name",
  documents: " Documents (sets)",
  domestic: " Domestic",
  DomesticDelivery: " Domestic Shipment",
  doubleAdd: " Creat B2B order",
  doubleAmount: " Total Amount",
  doubleClear: " Double List",
  doubleFeright: " CompleteInfo",
  doubleInfo: " Goods Info",
  doubleList: " B2B LIST",
  doublePrice: " Unit Price",
  gross: " Gross",
  doubleweight: " Gross Weight",
  down: " Take Down",
  download: " Download",
  download_tem: " Download Template",
  downloadLocationInfo: " Download Location Modify Info",
  driver_status: " Driver Availability",
  duty_rate: " Tariff",
  each: " Each",
  eachKG: " Per Kg",
  ECommercePacket: " E-commerce channel",
  ECommerChannel: " E-commerce Grocery Channel",
  editLocationInfo: " Modify Location Info",
  electricity_fee: " Electric Discharge Fee",
  ElectricityPCS: " CTNS with Batterires",
  email: " Mail",
  email_format: " E-mail Format Is Incorrect",
  email_subject: " Email Subject",
  En: " (english)",
  enable: " Enable",
  enableTime: " Enable Time",
  end: " End ",
  endGang: " Destination",
  English: " English",
  enter: " Please Enter",
  entry_fee: " Entry Fee",
  entryNo: " Warehouse No",
  equipment: " Source",
  error: " Fail",
  error_mes: " Error Message",
  error_value: " Acceptable Margin Of Error",
  Evidence_file: " Supporting Documents",
  excel_path: " Excel Link",
  exception_code: " Exception Code",
  exception_msg: " Abnormal Describe",
  exception_status: " Abnormal State",
  exception_time: " Abnormal Time",
  exception_type: " Exception Type",
  exceptionNum: " Abnormal Times",
  exceptionTracker: " Abnormal trajectory rules",
  Excess: " Excess",
  ExitExceptionRemark: " Exit Abnormal remark",
  exlType: " status",
  expand: " Expand",
  expected_date: " Eta",
  expense: " Subject Fee",
  expense_item: " Collection Item",
  expenseCode: " Fee Code",
  expenseName: " Fee Name",
  Expired: " Expired",
  export: " Export",
  export_tips_msg: " The Data Has Not Been Generated Yet, Try Again Later",
  express_currency: " Shipping Currency",
  express_fee: " Courier Fee",
  expStatus: " Export Status",
  expTime: " Export Time",
  expType: " Billing Type",
  extra_charge: " Operating Fee",
  extraCost: " Additional Charges",
  extract: " Bill Of Lading",
  extract_nums: " Bill Of Lading Quantity",
  extractList: " Bill Of Lading List",
  extractNew: " Create Bill of lading",
  f_agent_claim: " Claim Against The Responsible Party",
  fabAccount: " Client Account",
  fail: " Please Enter Relevant Information! ! !",
  fangdan: " Payment Method",
  fbaList: " Fba List",
  fee_type: " Types Of Fee",
  feedbackArea: " Delimited Area",
  feedbackNum: " Feedback Number",
  FeedbackPerson: " Feedback Person",
  feeTerms: " Shipping Terms",
  ferryCode: " Shipping Company Code",
  ferryName: " Shipping Company Name",
  fifth_140: " Five Time",
  fifth_140_time: " Five Days",
  fifth_delivery_remarks: " Five Reasons For Returning To The Warehouse",
  fifth_refuse_time: " Five Faction Refusal Time",
  file_fee: " Documentation Fees",
  fileAgent: " File Proxy",
  fileCnb: " Single Number File",
  fileName: " File Name",
  files: " File",
  finalCost: " Cost",
  finance: " Financial Management",
  finance_amount: " Financial Payment Amount",
  finance_currency: " Financial Payment Currency",
  financeEmail: " Financial Mailbox",
  finances: " Finance",
  financialZoning: " Financial Zoning",
  finish: " End",
  finish_time: " Days To Sign For The Whole Process",
  finished: " finished",
  finishTime: " End Time",
  first_140: " First Dispatch Time",
  first_140_time: " First Day",
  first_delivery_remarks:
    " The Reason For The First Dispatch Back To The Warehouse",
  first_party: " first party",
  first_refuse_time: " The First Refusal Time",
  firstWeight: " First Weight",
  firstWeightFreight: " First Freight",
  fixed: " Fixed",
  fixed_fee: " Fixed Charge",
  flight: " Flight",
  flight_time: " Shipping",
  flow: " Financial Flow",
  flow_num: " Serial Number",
  follow: " Follow Up",
  follow_up_customer_service: " Headquarters Follow Up Customer Service",
  FollowArea: " Follow Up Area",
  FollowCase: " Follow Up On The Case",
  FollowPerson: " Follower",
  followRecord: " Follow Up Record",
  FollowTime: " Follow Up Time",
  forecastManagement: " Forecast Management",
  form_data: " Please Complete The Form Data",
  FormalClearance: " Normal Customs Clearance",
  four_hours: " After 72 Hours",
  fourth_140: " Four Time",
  fourth_140_time: " Four Days",
  fourth_delivery_remarks: " Four Reasons For Returning To The Warehouse",
  fourth_refuse_time: " Four Faction Rejection Time",
  freeze_quantity: " Picking qty",
  freight: " Shipping Rules",
  freight_append: " Additional Fee",
  freight_fees: " Freight",
  freight_unit: " Receivable Currency",
  freightName: " Shipping Header",
  freightrule: " Parameter",
  from_channel: " Original Channel",
  from_city: " Departure City",
  from_country: " Origin",
  from_station: " Origin",
  FrontIDCard: " Id Card Front",
  fuel_fee: " Fuel Costs",
  fullName: " Full Name",
  gather: " Total",
  generate_bank_fee: " Generate Bank Charges Statement",
  generate_claim_bill: " Generate Claim Statement",
  generateBill: " Generate Warehouse Bills",
  generateBills: " Bills That Have Been Generated",
  go_to_review: " Enter Review",
  goods: " Product Stock",
  goods_nature: " The Nature Of The Goods",
  goodsSku: " SKU Information",
  group_name: " Group Name",
  group_name1: " Group Chat Name",
  growthRate: " Growth Rate",
  half_moon: " Half Moon",
  handle: " Deal With",
  handleFee: " Cod Customer Handling Fee",
  handler: " Handler",
  handling_opinions: " Handling Comments",
  HandlingFee: " Service charge",
  hang: " Hang",
  has_electric: " With Or Without Electricity",
  has_paper: " Is There Paper",
  has_tableware: " Whether With Tableware Logo",
  has_trademark: " With Or Without Brand",
  have: " Have",
  hedge_amount: " Consolidation Hedging Limit",
  hedge_t: " hedge",
  hedging: " hedge",
  height: " Height",
  Helian: " United",
  hide: " hide",
  high: " High Season Surcharge",
  highest: " highest",
  HKagency: " transportation agent",
  home: " Front Page",
  homeAbnormal: " Domestic Warehouse Abnormal Parts",
  hongkong: " Hongkong",
  hongkong_pickup_fee: " Hong Kong Delivery Fee",
  hq: " HQ",
  hsCode: " HS Code",
  hub: " Whether To Transfer",
  hw_bill_branch: " Overseas Bill (branch)",
  hw_shipment_branch: " Overseas Shipment Details (branch)",
  hwBill: " Overseas Bill",
  hwShipment: " Overseas Shipment Details",
  ignore_error: " Ignore Errors",
  img: " picture",
  immediately: " immediately",
  import: " Import",
  inactive: " Not Active",
  inbound: " Inbound",
  inbound_time: " Warehousing Time",
  inboundFordeal: " First Vessel Inbound",
  firstOrder: " First Vessel",
  inboundManifest: " Inbound SKU manifest",
  inboundStatus: " Warehousing Completed",
  inboundTime: " Inbound time",
  income: " Income",
  IncomingInspection: " Inbound Detection",
  indexes: " Index",
  info: " Message Notification",
  information: " Information",
  INSIDE_PARCEL: " Packaged Buns",
  inspectionPhoto: " Inspection Photos",
  instruction: " Instruction",
  instructionFile: " Instruction File",
  insurance_fee: " Insurance",
  internal: " Internal User",
  interval: " interval",
  Inventory: " Listed Inventory",
  invoice: " Bill",
  invoice_header: " Invoice",
  invoice_number: " Invoice Number",
  invoiceDescription: " Sku Code",
  invoiceHSCod: " Customs Code",
  invoiceInsValue: " Value",
  invoiceName: " Name",
  invoicePCS: " CTNS",
  invoiceWeight: " Weight",
  ip: " Ip Address",
  is_board: " Whether It Is In Stock",
  is_calculate: " Whether The Formula Is Calculated",
  is_def: " Default",
  is_goods: " Goods",
  is_hedge: " Whether Container Hedging",
  is_invoicing: " Whether To Invoice",
  is_oversea: " oversea warehouse",
  is_paid: " Paid",
  is_pod: " Whether Pod",
  is_publish: " Is It Public",
  is_solely: " Customs Declaration",
  is_unique: " Is It Unique",
  isAdditionalCharges: " Are There Any Additional Charges",
  isOrder: " Ordered",
  isPaper: " Does It Contain A Paper Version",
  isUnpack: " Whether To Unpack",
  items: " items",
  job: " job",
  job_number: " Job Number",
  jump: " jump",
  keyword: " Keyword",
  keywords_type: " Keyword Type",
  kongFee: " Air Freight",
  label: " Label",
  label_url: " Lable link",
  labelName: " Rule Name",
  landingTime: " Time Of Arrival",
  language: " Language",
  last_customer_nums: " Number Of Customers Last Month",
  last_month: " last month",
  last_order_nums: " Orders Last Month",
  last_order_pods: " Cod Receipts Last Month",
  lastCallTime: " Last Call Time",
  lastMonth: " Last Month",
  latest_delivery_remarks: " The Latest Reason For Restocking",
  latest_delivery_time: " Latest Delivery Time",
  launch: " Initiate",
  length: " Lenth",
  level: " Level 1",
  Level_child: " Child",
  Level_one: " Level 1",
  Level_two: " secondary",
  LibraryDay: " Daily Delivery",
  LinkedData: " Linked Data",
  liquidPCS: " CTNS with Liquid ",
  list: " List",
  ListData: " List Data",
  load_type: " Whether Customs Clearance Documents Are Required",
  localFaction: " Delivery Party",
  location: " Location",
  location_bill: " Location Bill",
  location_t: " Location",
  login: " Log In",
  lost_ticket_nums: " Lost",
  lowCost: " Low Consumption",
  lower_threshold: " Minimum Weight",
  lowest: " lowest",
  magnetic: " Magnetic",
  mail_note: " Mailing Notes",
  mainland: " Mainland",
  MaintainExchangeRate: " Maintain Exchange Rates",
  maitou: " Mark",
  manager_remarks: " Admin Notes",
  manifest: " Manifest",
  mapping: " Exception Mapping",
  mapping1: " Map",
  mapping_rule: " Mapping Rules",
  mappingChannel: " Mapping Channels",
  markField: " Mark Field",
  match_city: " City Grouping",
  match_client: " User Group",
  match_cod_amount: " Judging The Amount To Be Collected",
  match_cod_operator: " Collection Amount Operator",
  match_service_type: " Matching Service",
  match_values_amount: " Value Of Goods",
  match_values_operator: " Cargo Value Operator",
  material_fee: " material cost",
  mawb: " Bill Of Lading Number",
  max_weight: " Continued Weight",
  maxCall: " Maximum Number Of Calls",
  menuName: " Menu Name",
  menuRouting: " Menu Routing",
  message: " Information",
  messageList: " Message List",
  method: " Transportation Channel",
  method_code: " Shipping Code",
  method_name: " Transportation",
  methodTransfer: " Transfer method",
  middleGang: " Transit Port",
  min_weight: " First Weight",
  mini: " Mini",
  mobiledevice: " Handheld Devices",
  mode: "  Way",
  model: " Model",
  modify: " Revise",
  month: " Month",
  month_t: " Month",
  monthly_fee: " Monthly Fee",
  monthly_shipment: " Monthly Shipment",
  move: " Transport",
  MoveIn: " Move In",
  moveOperation: " More Actions",
  MoveOrder: " Move Into This Order",
  MoveOut: " Remove",
  multiple_details: " Multiple details comma separated",
  multiProduct: " Multi-product",
  n_process: " Un Processed",
  need: " Need",
  unNeed: " Unnecessary",
  needAssistPerson: " Remind People",
  NetworkError: " Network Anomaly",
  new_tracker_code: " Latest Track Code",
  new_tracker_time: " Update time",
  newAirWaybill: " New Air Waybill",
  newB2bPacking: " Creat transportation ref no.(B2B)",
  newest: " Up To Date",
  newPacking: " Creat transportation ref no.",
  newSeaWaybill: " New Ocean Bill Of Lading",
  newSecond: " New Secondary",
  newSouq: " New Souq",
  NO: " No",
  no_plan: " Solution Not Uploaded",
  noofpieces: " Quantity",
  noon: " Noon",
  noOrder: " Not Billed",
  noPass: " Fail",
  noResponse: " Not Responding",
  normal: " Normal",
  Not: " Not Yet",
  not_arrival_warehouse: " Shortages",
  not_bound: " Unbound",
  not_excel_tip:
    " Not an EXCEL file, please select an EXCEL file with a suffix of .xlsx or .xls.",
  not_listed_number: " Unavailable qty",
  not_stock: " Not out of stock",
  not_through: " Fail",
  not_update_time: " No Update Days",
  nothing: " None",
  notPick: " Un Pick Up",
  NotWrittenOff: " Not Written Off",
  now: " now",
  nowCallNum: " Current Number Of Calls",
  num_lengths: " Number Length",
  number: " Numerical Value",
  number_of_bags: " CTNS",
  number_of_shipment: " Total Votes",
  numMax: " Maximum",
  numMin: " Minimum",
  numPeople: " Number Of People",
  Odd_Numbers: " Single number",
  old: " Old",
  oms: " Internal End",
  on_shelve: " On Shelve",
  one_class: " Primary Classification",
  one_hours: " Within 24 Hours",
  onlineTime: " shelve time",
  onTheWayTicket: " on the way bills",
  open: " Announced",
  operate: " Operator",
  operate1: " creator",
  operation: "  Operation",
  operationLog: " Operation Record",
  operationModules: " Operation Module",
  operWarehouse: " Warehouse operation",
  order: " Order Module",
  order_address: " Consignee Address",
  short_address: "Short Address",
  order_address1: " Alternate Address",
  order_desc: " Remark",
  order_detected: " Whether To Detect",
  order_goods: " Product quantity",
  order_goods1: " Pcs",
  order_number: " Tracking Number",
  order_nums: " Orders This Month",
  order_pcs: " Package number",
  order_phone: " Consignee Phone",
  order_phone1: " ConsigneeTel",
  order_pods: " Cod Receipts This Month",
  order_price: " Collection Amount",
  order_rate: " Follow Up On Order Increases",
  order_recivre: " Consignee",
  order_refCode: " Ref Num",
  order_reset: " Reset",
  order_save: " Save To Draft",
  order_submit: " Submit",
  order_t: " Order",
  order_type: " Service Type",
  order_type1: " Service Type",
  order_type_t: " Order Type",
  order_userRef: " Shipper Ref No.",
  orderBlock: " Intercept",
  orderBlockRate: " Intercept Rate",
  orderConfirm: " Order Confirmed",
  orderDestroy: " Destroy Order",
  orderError: " Abnormal Order",
  orderErrorN: " Abnormal Order (new)",
  orderIn: " Inbound Order",
  orderInfo: " Order Information",
  orderIsUnique: " Is It Unique",
  orderList: " All Orders",
  orderNum: " Tracking Number",
  orderQuantity: "Box Number When Order Create",
  orderOutboundQuantity: "Box Number When Outbound",
  orderNums: " Quantity Of Order",
  orderOut: " Outbound Order",
  orderReturn: " Return order",
  orderRtc: " Return In Warehouse",
  orderRtw: " Return To Overseas Warehouse",
  orderservice: " Service Type",
  orderStatusList: " POD rate",
  orderTransferred: " Order Transferred",
  orderType: " current status",
  orderWait: " Order Not Confirmed",
  ordinary: " Ordinary",
  ori_pack: " Original Packages Order Inventory",
  ori_pack_cnb: " Old cnb number",
  original: " Original",
  original_packing_num: " Original Single Box Number",
  original_shelves: " Original Package Available",
  originalCodAmount: " Total amount of original COD",
  OriginalCurrency: " Original Currency",
  orther: " Other ",
  otherCost: " Other Fee",
  out: " Outbound",
  out_number: " Actual Shipment",
  whole: " Whole",
  outbound: " Outbound",
  outbound_quantity: " Outbound qty",
  outbound_time: " Outbound time",
  Outboundrecord: " Outbound Record",
  outboundTime: " Outbound time",
  outerBoxNumber: " Outer Box Number",
  outNumber: " PCS",
  OutOrderNum: " Number Delivery",
  outTicket: " Delivery",
  outTicket_rate: " Delivery Rate",
  outTimeday: " Timeout Days",
  overload_fee: " Excess fee",
  overseas: " Overseas Warehouse",
  Overseasdistribution: " Overseas picking",
  overseasNumber: " MaBang Order Number",
  overseasOrderList: " MaBang Order list ",
  overseasWarehouse: " MaBang Overseas Warehouse",
  overtime: " Time Out",
  overtime_fee: " Overtime Pay",
  overtime_order: " overtime order",
  overweight_fee: " Overweight fee",
  ownerCountry: " Country Of Origin",
  ownership: " The subject company",
  package: " Agent Package",
  package1: " Co-package",
  PACKAGE_CONCLUDED: " Co-package",
  package_number: " Package Number",
  packageOrder: " Package Concluded",
  packageTitle: " Show Channel",
  packageType: " Parcel Type",
  packet: " Packet",
  packetReport: " Small Package Report",
  packing: " China-hong Kong Bill",
  packing_freight: " China And Hong Kong Freight",
  packing_number: " transportation ref no.",
  packingData: " China-hong Kong Single Data",
  packingList: " List of  transportation ref no.",
  packingNum: " Carton No.",
  packingNumber: " China And Hong Kong Odd Number",
  page: " This Page",
  pageButton: " Page Button",
  pageName: " Page Name",
  paid: " Payment Amount",
  paid_for: " paid for",
  paid_time: " Payment Time",
  paper_fee: " Tariff Information Fee",
  paramsAccount: " Parameter Account",
  paramsAgent: " Home Agent",
  paramsPwd: " Parameter Password",
  paramsSet: " Parameter Key",
  paramsType: " Parameter Type",
  paramsUrl: " Parameter Address",
  parking_fee: " Parking Fee",
  partitionCode: " Partition Code",
  partitionName: " Partition Name",
  paServicePerformance: " Small Packet Customer Service Performance",
  pass: " Pass",
  pass_nums: " Number Of Compliance",
  pass_rate: " Compliance Rate",
  password: " Login Password",
  pathIcon: " Icon",
  pathName: " Chinese Name",
  pathUrl: " Path",
  pay: " Pay",
  pay_way: " Channel Source",
  payable_amount: " Amounts Payable",
  payable_cost_total: " Total Costs Payable",
  payable_currency: " Payable Currency",
  payable_expenses: " Fees Payable",
  payBalance: " Debit",
  payment: " Payment Mode",
  payment_account: " Account Name",
  payment_description: " Describe",
  payment_freight: " Shipping Fee",
  payment_title: " Payment Instructions",
  paymentCode: " Payment Code",
  paymentType: " Service Type",
  peak_fee: " High Season Surcharge",
  Pending: " To Be Processed",
  per_ticket: " Per Ticket",
  performance: " Performance Management",
  period: " Checkout Cycle",
  personal_cn: " Personal Chinese Name",
  personal_en: " Personal English Name",
  personnel: " Personnel",
  phone: " Cellphone Number",
  phoneError: " Wrong phone number",
  phoneErrorRate: " Wrong phone number Rate",
  PhoneNotResponding: " No reponse",
  PhoneNotRespondingRate: " No reponse Rate",
  pick: " Pickup",
  picked: " Picked Quantity",
  picker: " Courier",
  pickImage: " Photos",
  Picking: " Picking",
  pickingStatus: " Picking Status",
  pickList: " Picking Order list",
  pickupNumber: " Pick List Number",
  placeOrder: " Place An Order",
  plan: " plan",
  plan1: " Solution",
  plan_location: " Location",
  plan_remark: " Return Remak",
  plan_t: " Plan",
  planName: " Scheme Name",
  planReturn: " Return",
  planStatus: " Process Result",
  planSub: " Submit The Plan",
  pod: " POD",
  pod_num: " POD Quantity",
  pod_rate: " POD Rate",
  pod_type_txt: " Pod Type",
  PodAlready: " Pod",
  podError: " Abnormal POD list",
  popup: " Pop-ups",
  port: " Port Management",
  portal: " Client",
  portCode: " Port Code",
  portName: " Port Name",
  positive: " Positive",
  postal_usage_fee: " Postal Usage Fee",
  preferential: " Preferred Header",
  prefix: " Bag Prefix",
  Prepaid: " Prepaid",
  prepaid_fee: " Disbursement Fee",
  Press: " According To",
  pretendNumber: " Qty",
  preview: " Pre-view",
  price_t: " Price",
  print: " Print",
  process_status: " status",
  processing_time: " Processing Time",
  ProcessingProgress: " Processing Progress",
  productName: " Product Name",
  profit: " Gross Profit",
  profit_rate: " Gross Profit Margin",
  prospecting_fee: " Geological Exploration Fee",
  province: " Province",
  proxyException: " Proxy Exception",
  proxyPush: " Proxy Push",
  public: " public",
  publicAuth: " Public Authority",
  publish: " Release",
  publisher: " Publisher",
  push: " Push",
  pushClinet: " Push Customer",
  pushed_time: " Push Time",
  pushProxy: " Push Proxy",
  qq: " Qq",
  quantity: " Number Of Locations",
  quantity_analysis: " Quantity In Current Analysis",
  quantity_num: " PCS",
  querySearch: " Inquire",
  midMonthData: " Mid Month Data",
  rate: " Exchange Rate",
  rateDiff: " Exchange Rate Difference",
  ratio: " Proportion",
  re_enter: " Please Don't Re-enter!",
  re_start: " Relaunch",
  Read: " Have Read",
  read_error: " read exception",
  read_time: " Reading Time",
  read_to_confirmed: " Confirmed to read",
  ready: " Prepare",
  realname: " Name",
  rearEnd: " Rear End",
  reason: " Reason",
  reason_billing: " Billing Reason",
  ReasonFeedback: " Reason For Feedback",
  RebatesRefundsDiscounts: " Rebates/Refunds/Discounts",
  ReceiptRate: " Sign-off Rate",
  receiptTicket: " POD bills",
  receiptTime: " POD Time",
  receivable: " Receivable",
  receivable_expenses: " Fees Payable",
  receivableReport: " Cod Receivable Statement",
  ReceivableSummary: " Receivable Summary",
  received_agent_claim:
    " Compensation Has Been Received From The Responsible Party",
  received_agent_claim_date:
    " Date Of Receipt Of Compensation By The Responsible Party",
  received_company: " Receiving Unit",
  reChAmount: "  Amount",
  recharge: " Recharge",
  recipientInfo: " Recipient Information",
  record: " Record",
  Redistribute: " Re-delivery",
  refund: " Refund",
  refund_address: " Refund Address",
  refundAmount: " Amount To Be Refunded",
  refunded: " refunded",
  refundHandlingFee: " Summary Of Refundable Fees",
  refundReport: " Cod Should Be Returned Statement",
  refundSummary: " Refundable Summary",
  refundtotal: " Always Return",
  refusal_number: " Refusal Count",
  refusal_rate: " Visa Refusal Rate",
  refuse: " Reject",
  refuse_number: " Refusal Count",
  refuse_rate: " Rejection Rate",
  refuse_t: " Refuse",
  refuse_t_rate: " Refuse Rate",
  reject: " Reject",
  reject_client: " Reject Client",
  reject_prel: " Dismissed The First Trial",
  related: " Related",
  RELATED_CNBS: " Associated Votes",
  RELATED_CTNS: " Number Of Related Pieces",
  relatedMe: " Related To Me",
  relatedOther: " Associate Other",
  relatedPersonnel: " Associates",
  relation: " Association",
  Remaining_available: " Remaining available",
  REMARK: " Customer Service Remark Instructions",
  remarkPlaceholder:
    " The Calculation Rules Of The Claim Amount, The Origin Of The Amount, And Other Details",
  Remarks: " Remark",
  remote_fee: " remote fee",
  remote_regions: " Are Remote Areas",
  remote_regions_fee: " Remote Surcharge",
  RemoveOrder: " Remove This Order",
  reOrder: " Re-order",
  replace_currency: " Receipt Currency",
  report: " Report",
  report_location: " Location Detail",
  report_time: " Reporting Time",
  request_time: " Interception Time",
  resAmount: " Recalculate",
  reserve: " reserve",
  reserve1_rate: " Future delivery rate",
  reserve1: " Future delivery",
  residence_time: " In Hong Kong",
  Responsibility_party: " Responsible Party",
  responsible_claim: " Responsible Party Claims",
  reStatistics: " Re-statistics",
  result: " Result",
  result_see: " Please Go To The Result List To View",
  retired_times: " Delivery Count",
  return: " Return",
  return1: " return",
  return_t: " Return",
  returnException: " DTO Order Abnormal",
  returnOrder: " Return order list",
  returnPick: " DTO Order List",
  returnRefund: " Refund shipments",
  reverse: " Reverse",
  ReverseIDCard: " Id Card Back",
  reviseProcessStatus: " Modify Processing Status",
  riskControl: " Quota Risk Control",
  role: " Role Management",
  role_map: " Role Mapping",
  role_t: " Role",
  roleAuth: " Role Permissions",
  roleName: " Role Name",
  roleSort: " Role Permissions",
  routeCode: " Route Code",
  routeName: " Route Name",
  routingAddress: " Routing Address",
  rule_sel_tips: " At most one customer can be selected",
  rule_supplier: " Provider",
  s_package_report: " Small Package Summary Report",
  salesman: " Sales",
  salesman_remarks: " Business Notes",
  shipInvoices: "Declaration documents",
  sea: " Shipping Company Management",
  sea_freight: " Ocean Freight",
  sea_transport: " Sea Freight",
  seaIncome: " Shipping Income Entry",
  seal: " Seal",
  search: " Search",
  seaWaybillList: " List Of Ocean Bills Of Lading",
  second_140: " Second Time",
  second_140_time: " Second Party Days",
  second_delivery_remarks:
    " Reasons For The Second Party To Return To The Warehouse",
  second_refuse_time: " Second Party Refusal Time",
  security_fee: " Security Fee",
  selDocument: " Selected File",
  select: " Please Choose",
  selected: " Checked",
  selectPrint: " Select Print",
  self_mention: " Pick Up",
  sell: " Sell",
  send: " Send",
  DELIVERY_TIP:
    " Please confirm not to modify the information to continue delivery",
  TO_WMS_TIP: " Whether to perform transfer to overseas warehouse operation",
  PICKUP_TIP: " Whether to continue the pickup operation",
  send_express: " Send Express",
  send_price: " Home Delivery Fee",
  Sender: " Shipper",
  separateDeclaration: " Customs Declaration",
  serial_number: " Sl.no",
  serialNumber: " Sl.no",
  service: " Customer Service",
  SERVICE_ITEM: " Deliverer",
  serviceAccount: " Customer Service",
  shipInfo: "Booking Information",
  shipDocument: "Ship Plan",
  seaShipperName: "Shipper Name",
  createSeaUser: "Documenter",
  serviceName: " Small Package Customer Service",
  serviceProcessed: " Waiting For Customer Service",
  serviceType: " Service Item",
  SetOriginalCurrency: " Settlement Original Currency",
  setting: " Set Up",
  seven_pod_rate: " 7-day Sign-off Rate",
  share_type_txt: " Allocation Type",
  sheet: " Label",
  shipAgent: " Shipping Agent",
  shipCost: " Shipping Agency Cost",
  shipment: " Small Package Shipment Details",
  shipment_all: " Shipment",
  shipment_place: " Place Of Shipment",
  shipmentBatch: " Shipment Batch",
  shipmentBranch: " Small Package Shipment Details (branch)",
  ShipmentDetails: " Shipment Details",
  shipmentNumber: " shipping quantity",
  SHIPMENTS: " Votes",
  shipmentTicket: " shipping bills",
  shipmentTime: " HAWB shipping time",
  shipmentvolume_seven_days: " Shipments In The Last 7 Days",
  shipmentWeight: " Shipping Weight",
  shipper_company: " Shipping Company/consolidator Id",
  shipper_company_cn: " Company name",
  shipper_company_en: " Company English Name",
  shipper_mobile: " Contact Number",
  shipper_telephone: " Seller After-sales Contact Number",
  shipperAddress: " Shipping Address (english)",
  shipperCode: " Sender Code",
  shipperName: " Sender Name",
  shipperRef: " Shipper Ref No.",
  shipperRef1: " Shipper Ref",
  shipping_agent: " Shipping Agency",
  shipping_company: " Shipping Company",
  shipping_mode: " Shipping Mode",
  ShippingDate: " Ship Date",
  shippingInfo: " Address Infomation Service",
  shippingTerms: " Shipping Terms",
  shop_name: " Store Name",
  shopName: " Store Name",
  should_delivery_time: " Time To Be Dispatched",
  shouldCallNum: " Should Be Called",
  show: " Check",
  showDetail: " Show",
  show1: " Show",
  Shuangqing: " B2b",
  signDownload: " Download The Receipt",
  SignedAmount: " Signed Volume",
  singleBox: " Single Box Quantity",
  singleProduct: " Single Product",
  site_name: " Site Name",
  size: " Size",
  sku: " SKU information",
  skuAlias: " Fake Product Name",
  skuAmount: " Declared Value",
  skuCode: " Customer Code",
  skuHeight: " High",
  skuInfo: " Cargo Details",
  skuLength: " Length",
  skuName: " Product Name",
  skuName1: " Product name",
  skuTitle: " Sku description",
  skuTitle1: " SKU Name",
  skuVolume: " SKU Volume",
  Volume: " Volume",
  skuWeight: " SKU weight",
  skuWeight1: " Gross Weight",
  skuWidth: " Width",
  sll_weight: " Minimum Weight",
  small_package_audit: " Small Package Audit",
  sms: " Sms Template",
  sms_warning: " Warn",
  sort: " Sort Value",
  souq: " Souq Order",
  souqNum: " Souq Tracking Number",
  source: " Source",
  spare_contract_header: " Alternative Contract Header",
  spc_way_weight: " Special Billing Weight",
  special: " Special",
  special_remark: " special remark",
  specialRule: " Special Rules",
  specialSign: " Special Receipt",
  specific: " Specific",
  sponsor: " creator",
  square: " Volume",
  standard: " Standard",
  standard_role: " Map Roles",
  start: " Start ",
  startGang: " Port Of Departure",
  startingTime: " Start time",
  startStatist: " Start Counting",
  startToend: " Contract Start Date",
  statistics: " Statistics",
  status: " available",
  status_cn: " Process Info (CN)",
  status_flag: " Entry Id",
  status_hidden: " Whether To Hide",
  status_location: " Track Location",
  status_operator: " Operator",
  status_time: " Update time",
  status_time1: " Update time",
  status_timezone: " Track Time Zone",
  stayDone: " To Be Completed",
  step_price: " Renewal Fee",
  sticker_fee: " Veneer Labeling Fee",
  stock: " SKU Inventory",
  storage: " Storage Mgmt",
  storage_quantity: " The Maximum Number Of Deposits This Month",
  storageFee: " Storage Fee Details",
  store_name: " Store Name",
  subcontract: " Subcontract",
  subcontractForecastList: " B2B E-commerce",
  submitUser: " Submitter",
  subPackage: " Subcontract",
  subPackage1: " Subpackage",
  subplan: " Submit A Plan",
  success: " Success",
  summary: " Summary",
  summary_ship_details: " Cost Summary Details",
  summaryBill: " Billing Summary",
  supplier: " Client Account",
  switchChannel: " Switch Channel",
  synchronous: " Synchronous Data",
  sys: " System",
  sysLabel: " Drawing Rules",
  system: " Settings Management",
  system_shelf: " System Launch",
  systemSub: " System Launch",
  takeOffTime: " Departure time",
  target_airport: " Origin",
  target_channel: " Switch Channel",
  target_country: " Destination",
  task_no: " Summary Bill Number",
  tax: " Tax",
  tax_currency: " Tariff Currency",
  tax_fee: " Tariff",
  taxCurrency: " tax currency",
  taxFee: " Taxes",
  telephone: " Contact Number",
  template: " Template",
  template_content: " Template Content",
  template_name: " Template Name",
  ten_pod_rate: " 10-day Sign-off Rate",
  the_smaller_value: " The smaller the value, the higher the order",
  Thetwopasswords: " The Two Passwords Do Not Match",
  third_140: " Three Times",
  third_140_time: " Three Days",
  third_delivery_remarks:
    " Reasons For The Three Factions To Return To The Warehouse",
  third_refuse_time: " Three Faction Refusal Time",
  this_month: " this month",
  thisMonth: " This Month",
  three_hours: " 48-72 Hours",
  three_party: " Three factions",
  three_pod_rate: " 3-day Sign-off Rate",
  threshold: " Tariff Threshold",
  threshold1: " Threshold",
  through: " Pass",
  time: " Time",
  time_in_transit: " Days In Transit",
  time_in: " on the way",
  time_in_rate: " on the way Rate",
  time_not_31day: " The period cannot exceed 31 days",
  timelyDelivery: " Timely Delivery",
  timeoutUnsent: " Delay delivery list",
  timesAnalysis: " Report Center",
  timesList: " Aging List",
  timeType: " Time Type",
  timezone: " Time Zone Management",
  timezoneFormat: " Time Zone Format",
  timezoneName: " Time Zone Name",
  tip: "  Status",
  tip1: " Tips",
  titleModal: " Do You Want To Do This?",
  to: " Convert",
  to_rmb: " CNY",
  to_station: " Destination",
  to_usd: " USD",
  to_sar: " SAR",
  to_aed: " AED",
  toCurrency: " Target Currency",
  toggle: " Toggle",
  toHKtime: " ATA",
  ToPay: " Collect",
  total: " Total",
  total_amount: " Lump Sum",
  total_fee: " Total Handling Fee",
  Total_original_currency: " Total original currency amount",
  total_out_ticket_nums: " Total bills",
  TOTAL_PARCEL: " Total Order Tickets",
  total_tax: " Total Tax",
  total_votes: " Total Ctns",
  total_votes1: " Total order",
  totalAeclaredAmount: " Total Declared Value",
  totalArrears: " Total Arrears",
  totalNoofpieces: " Pieces Number",
  totalNumber: " The Total Number",
  TotalReceivable: " Total Receivable",
  totalWeight: " Package Weight",
  trace: " Agent Trajectory Mapping",
  track_title: " Process Info",
  tracker: " Transportation Management",
  tracker_code: " Track Code",
  tracker_description: " Process Info",
  tracker_description_cn: " Chinese Description",
  trackerCities: " City Grouping",
  trackerClients: " Customer Grouping",
  trackererror: " Trajectory Mapping Error List",
  trackerparams: " Proxy Parameters",
  trackerStatus: " Track Management",
  trackerSwitch: " Rule Switching",
  tracking_number: " Return way remark",
  trackingNumber: " Shipment Tracking Number",
  trackRecord: " Record Track",
  trademark: " Trademark",
  trajectory: " Track",
  transaction_id: " Bank Transaction Flow",
  transfer_num: " Tracking Number",
  transfer_order: " Transfer Order",
  transferList: " Transfer order pick list",
  TransferOrder: " Transfer Order",
  transport_method: " Transportation",
  transport_mode: " Transportation Channel",
  transportCost: " Transportation Costs",
  TravelStatus: " Trip Status",
  tuoyunUser: " Shipping Merchandiser",
  turn: " Change",
  turn_to: " go to",
  two_hours: " 24-48 Hours",
  two_party: " Two factions",
  type: " Type",
  unapod: " Not Signed",
  Unbilled: " Unbilled",
  unbind: " Unbind",
  unConfirm: " Weight Not Confirmed",
  UngeneratedBills: " Ungenerated Bill",
  unInventory: " Unlisted Stock",
  unit: " Unit Management",
  unit_t: " Unit",
  unitName: " Company Name",
  unpack: " Unpacking",
  unpack_sheves: " Unpack And Put On The Shelf",
  unpackEnquiry: " B2B-Subpackage",
  unpaid: " Unpaid",
  unperfect: " Not Perfection",
  Unread: " Unread",
  UnrefundedAmount: " Outstanding Amount",
  up: " On The Shelf",
  update: " Update",
  updateFile: " Upload",
  updateLog: " Modify Records",
  updatePwd: " Update Password",
  newPwd: " new Password",
  changePWd: " Change Password",
  updateTrace: " Batch Update trajectory",
  upload: " Please Upload",
  uploaded: " File Uploaded",
  uploadLocationInfo: " Upload Location Modify Info",
  uploadRes: " Upload Results",
  uploadTe: " (such As Purchase Invoice, To Prove The Value Of The Product)",
  uploadText: " Click Or Drag Files Or Images To Upload",
  upper_threshold: " Maximum Weight",
  upTime: " Update Time",
  use_quantity: " Available qty",
  Useless: " No",
  user: " User Management",
  user_name: " Username",
  userName: " Login Account",
  userPwd: " Login Password",
  value: " Value",
  values: " Value Of Goods",
  valueService: " value-added servic",
  VAT_charges: " Vat Rate",
  vat_fee: " Sale Tax",
  vat_rate: " Vat Rate",
  VATFee: " Vat Fee",
  verify_status: " Audit status",
  virtual_airway_number: " Virtual Tracking Number",
  virtualWarehouse: " Virtual Warehouse Operation",
  virtualWH: " Virtual Warehouse",
  vnlinTrackCode: " Joint Track Code",
  Votes: " Votes",
  wait: " Treat",
  modifyCodRecords: " Modify Cod Records",
  Wait_Picking: " To Be Picked",
  waitError: " Exception Pending",
  warehousCustomsAgent: " Warehouse Customs Broker",
  warehouse: " Warehouse",
  warehouse_fee: " Storage Fee",
  warehouse_in_out: " In And Out Of Warehouse",
  warehouse_name: " Shipping Warehouse",
  warehouse_return_rate: " Return Rate",
  warehouse_status: " Exception Type",
  warehouse_t: " Storehouse",
  warehouse_time: " Time To Destination Warehouse",
  warehouseAddress: " Warehouse",
  warehouseAddress1: " Overseas Warehouse Shipping Address",
  warehouseCity: " Warehouse City",
  warehouseCode: " Warehouse Code",
  warehouseID: " Warehouse Id",
  warehouseManagement: " Warehouse Mgmt",
  warehouseName: " Warehouse name",
  warehouseName1: " Warehouse",
  warehouseName2: " Warehouse operation",
  warehousePhone: " Overseas Warehouse Receiving Phone Number",
  waybillNumber: " Waybill number",
  WaybillPickingStatus: " Waybill Picking Status",
  wechat: " Wechat",
  week: " Week",
  Weight: " Weight",
  weights: " Weights",
  whether: " Whether",
  include: " Include",
  whitelist: " Whitelist",
  width: " Width",
  wight: " Total weight",
  withdraw: " Withdraw",
  writeOff: " Write Off",
  WrittenOff: " Written Off",
  wrong: " wrong",
  y_process: " Processed",
  YES: " Yes",
  yesterday: " yesterday",
  zaji_mapping: " Zajil City Map",
  Zh: " (chinese)",
  zhTitle: " Title",
  zip_code: " Post Code",
  CollectionUser: " Collection User",
  writeOffDetail: " Write Off Detail",
  createCostBill: " Create Cost Bill",
  refund_address: " Payment Collection Address",
  ShipmentDetails: " Shipment Details",
  HQClient: " HQ Client",
  file30M: " The file cannot exceed 30M",
  summary_ship_details_new: " Summary Ship Details New",
  pod_time: " Pod Time",
  pod_time1: " Signed Time",
  bill_hq: " Bill HQ",
  AmountHedged: "Amount Hedged",
  transportation: "transportation",
  Required: "Required",
  PickUp: "Pick up goods",
  Contacts: "Contacts",
  deliverGoods: "Delivery",
  numberPlate: "License Plate Number",
  address: "Address",
  PickAtDoor: "Door to door picking up",
  SelfDelivery: "self delivery",
  ExpressLogistics: "Express /logistics delivery to vnlin warehouse",
  ExpressLogisticsName: "Express/Logistics Name",
  ExpressLogisticsNumber: "Express/Logistics Number",
  changeOrder: "Change order",
  preparing: "Preparing",
  PackingSlip: "Packing Slip",
  ListOverseasWarehouses: "Overseas warehouse shelves with goods list",
  DoorServicePackingList: "Door to Door Service Packing List",
  msg_401: "You do not have permission to view this page",
  msg_404: "Your page seems to fly away",
  msg_500: "Ghost knows what's going on with the server",
  NoData: "No data",
  ClaimsLetter: "Claims Letter",
  Collection_t: "Collection",
  city_t: "City",
  RemoteRegions: "Remote Regions",
  delivery_t: "Delivery",
  crossPort: "cross port",
  objection: "There is objection",
  Settled: "Settled",
  MAWB: "MAWB NO.",
  two_class: "Second Class",
  picking_t: "picking",
  onLine: "Online",
  offLine: "Offline",
  expenseNameEn: " Fee Name En",
  branch_shipment: " Small Package Shipment Details",
  branch_bill: " Small Package Bill",
  TrailerCustomsBroker: "Trailer Customs Broker",
  b2bDetailTip:
    " Current inflow rule：Order module, B2B order page, need to have entry, exit, and submit perfect information at the same time",
  cod_amount1: " COD Amount",
  destination: " Destination",
  reimburseManage: "Reimburse Manage",
  reimburseCategory: "Reimburse Category",
  CategoryName: "Category Name",
  reimburseApply: "Reimburse Apply",
  inReview: "In Review",
  Passed: "Passed",
  Rejected: "Rejected",
  detailName: "Detail Name",
  detailAmount: "Detail Amount",
  reimburseDetail: "Reimburse Detail",
  approvalAmount: "Approval Amount",
  ApprovalPending: "Approval Pending",
  approval: "Approval",
  proposer: "Proposer",
  ImportCargo: "Import Cargo",
  costSuject: "Cost Suject",
  sujectName: "Suject Name",
  endTripManage: "Last Mile MAWB Mgmt",
  safetyAgent: "Safety Agent",
  up_t: "Up",
  down_t: "Down",
  charge_params1: " Charge Weight",
  hw_bill_hq: "Overseas bill HQ",
  hw_shipment_hq: "Overseas Shipment HQ",
  medium: " Medium",
  ox: "1x",
  tx: "2x",
  costCategories: "Cost Categories",
  endTripFee: "End Trip Fee",
  zx: "0x",
  incomeSubject: "IncomeSubject",
  reimburse: "Reimburse",
  repeal: "Repeal",
  alreadyRepeal: "Already Repeal",
  location_bill_hq: "Location Bill Hq",
  my: " My",
  platReturnService: "Amazon/Noon Return Service",
  returnPlatform: "Return Platform",
  shopId: "Store ID",
  trackingCode: "Tracking number",
  ReturnTime: "Return Time",
  ReceiptSign: "Receipt Sign",
  ReceiveTime: "Receive Time",
  addTime: "Add Time",
  WarehouseNotes: "Warehouse Remark",
  platform: "Platform",
  approval_status: " Approval Status",
  inReview_my: "When I review",
  Passed_my: "I already Passed",
  Rejected_my: "I already Refuse",
  reimburseSuject: "Reimburse Suject",
  personal: " Personal",
  airIncomeBill: "Air Income Bill",
  USD: " USD",
  HKD: " HKD",
  SAR: " SAR",
  createName: " Create Name",
  airIncomeDetail: "Air Income Detail",
  to_hkd: " HKD",
  to_sar: " SAR",
  check_remarks: "Check Remarks",
  to_cny: " CNY",
  comfirmUser: "Comfirm User",
  writeOffUser: "WriteOff User",
  orderNumberInexistence: "The following order number does not exist",
  InletTime: "Inlet Time",
  location_hq: "Location HQ",
  PickUpType: "Pick Up Type",
  PickUp1: "Pick Up",
  HomeDelivery: "Home Delivery",
  to_qar: "QAR",
  to_kwd: "KWD",
  b2b_bill_hq: "B2B Bill HQ",
  PortalFinancialModule: "Portal Financial Module",
  b2b_details_hq: "B2B Details HQ",
  hongKongPlus: " Hong Kong Plus",
  join: " Join",
  bubbleType: " Bubble Type",
  quantity1: " Charge number",
  sticker: " Sticker",
  syncDeliveryFee: "Sync Delivery Fee",
  ClientCNFullName: "Client CN Full Name",
  ClientCode: "Client Code",
  firstFee: "First Fee",
  AirOrSeaFreight: "Air/Sea Freight",
  endTripFee1: "End Trip Fee",
  Stevedorage: "Stevedorage",
  TransferFee: "Transfer Fee",
  ReconciliationUser: "Reconciliation User",
  PackShipmentNumber: "Pack Shipment Number",
  ShipmentGoodsNumber: "Shipment Goods Number",
  CNBOrder: "CNB Order",
  referCode: "Refer Code",
  branch_claim_list: "Claim List",
  documentsFee: "Documents Fee",
  TrailerOrForkliftFee: "Trailer Or Forklift Fee",
  shipmentAgency: "Shipment Agency",
  createDeliveryBill: "Create Delivery Bill",
  ffc: "FFC",
  ffcShipments: "FFC Shipments",
  returnShipments: "Return Shipments",
  delayShipments: "Delay Shipments",
  deliveryPerformanceSLA: "Delivery performance SLA",
  abnormalShipments: "Abnormal Shipments",
  Append: "Append",
  DelDetail: "Del Detail",
  billingCycle: "Billing Cycle",
  extractCost: "Extract Cost",
  ContactInformation: "Contact Information",
  BusinessPhone: "Business Phone",
  BranchBa: "Branch Bank",
  AccountOpeningUsername: "Account Opening Username",
  BankCode: "Bank Code",
  iban: "Large bank/joint bank",
  cod_currency: "Cod Currency",
  FreightVATRadio: "Freight VAT Radio",
  b2b_cost: "B2B Cost",
  save: "Save",
  safetyService: "Insurance service",
  next_page: "Page",
  first_bill: "First Bill",
  secondary_bill: "Secondary Bill",
  lostList: "Lost Item List",
  LostPieces: "Lost Pieces",
  CorrectDeliveryCost: " Correct Delivery Cost",
  Sync: " Sync",
  InsufficientBalance: "Insufficient Balance",
  other_fee: " extra fee",
  other_fee_hq: " extra fee",
  reserve_number: " Reserve Number",
  carton_nums: " CTNS",
  suject: " Suject",
  createIncomeBill: "Create Income Bill",
  costRule: "Cost Rule",
  rule: " Rule",
  object: " Object",
  User: " User",
  childOrder: "Child Order",
  newAirWaybillN: 'New Air Waybill New',
  entrust: ' Entrust',
  businessUser: 'Business User',
  liquid: ' Liquid',
  warehousingNumberManagement: 'Warehousing Number Management',
  warehousingNumber: ' Warehousing Number',
  warehousingInformation: 'Warehousing Information',
  batch_number: ' Batch Number',
  warehousing: 'Warehousing',
  lost_rate: 'Lost Rate',
  billingStatus: 'Billing Status',
  accepted: ' Accepted',
  PendingWriteOff: 'Pending WriteOff',
  skipServiceCheck: 'Skip Service Check',
  causeDescription: 'Cause Description',
  hw_surcharge: 'Overseas Surcharge',
  CustomsHold_t: " Customs hold",
  CustomsHoldRate_t: " Customs hold rate",
  receivableTotal: ' Receivable Total',
  epidemic: ' Epidemic',
  subtotal: ' Subtotal',
  WeightAfterUsingCarton: 'Gross weight(CTN)',
  VolumnAfterUsingCarton: 'Volume weight(CTN)',
  Rule: ' Rule',
  Single: ' Single',
  AmountBetween: ' Amount Between',
  ChargingReassignment: ' Charging Reassignment',
  AgentContract: 'Agent Contract',
  Invalid: 'Invalid',
  destroy_rate: 'Destroy Rate',
  forecast: "Forecast",
  transactionNumber: "Transaction Number",
  MarkAbnormal: 'Mark Abnormal',
  Dimension: ' Dimension',
  def: ' Default',
  b2b_charging_type: 'B2B Quotation Charging Type',
  field: ' Field',
  deliveryService: 'Delivery Service (FBA/FBN)',
  Delivery: ' Delivery',
  LabelsNeedReplaced: ' Labels Need Replaced',
  labelIsReplaced: ' Label Is Replaced',
  WarehouseOut: ' Warehouse Out',
  CargoLabel: ' CargoLabel',
  SkuLabel: ' SkuLabel',
  PDFFile: ' PDF File',
  Change: ' Change',
  clearanceQuotationRule: 'Clearance Quotation Rule',
  endTime: ' End Time',
  transport_fee: ' Transport Fee',
  billingVAT: ' Billing VAT',
  deliveryAgentSwitch: ' Delivery Agent Switch',
  endTripIncomeBill: ' endTrip Income Bill',
  NextProcessing: ' Next Processing',
  takenMode: ' Taken Mode',
  fullPrice: ' Full Price',
  halfPrice: ' Half Price',
  order_pcs1: " Pieces Number",
  outboundCtns: 'outbound ctns',
  CODServiceCharge: 'COD service charge',
  CODFee: 'COD Fee',
  Inboundpcs: 'Inbound pcs',
  HSCode: 'SKU Barcode',
  SKUBarcode: 'SKU Barcode',
  CODCurrency: 'COD Currency',
  CODAmount: 'COD Amount',
  UnpackedFinished: 'Unpacked Finished',
  UnpackedFinished1: ' whether complete',
  ConfirmedWeight: ' Confirmed the Weight',
  B2BECommerce: 'B2B E-commerce',
  ValueAddedServiceFees: 'Value-added service fees',
  InboundWarehouse: 'Inbound warehouse',

  "Excel Batch add": "Excel Batch add",
  "Pending create order": "Pending create order",
  "Finish time": "Finish time",
  "Transport info": "Transport info",
  "Goods Info": "Goods Info",
  "Carton No.": "Carton No.",
  "Other Remark": "Other Remark",
  "Other Info": "Other Info",
  "Customs Declaration": "Customs Declaration",
  "Document Declaration": "Document Declaration",
  "Document Set": "Document Set",
  "Quotation Info": "Quotation Info",
  "Export Details": "Export Details",
  "Pre-view price": "Pre-view price",
  "choose price": "choose price",
  "setup the fixed price": "setup the fixed price",
  "Item collection": "Item collection",
  "Currency": "Currency",
  "Revise  CTNS": "Revise CTNS",
  "Upload doc": "Upload doc",
  "The delivery type": "The delivery type",
  "Contact person": "Contact person",
  "pick up address": "pick up address",
  "Download Address": "Download Address",
  "Reject": "Reject",
  "Excel doc": "Excel doc",
  "Process Info (CN)": "Process Info (CN)",
  "Consignee Address": "Consignee Address",
  "Consignee Phone": "Consignee Phone",
  "ConsigneeTel": "ConsigneeTel",
  "Total Product quantity": "Total Product quantity",
  "Update time": "Update time",
  "Company name": "Company name",
  "Refund Reason": "Refund Reason",
  "Refund Amount": "Refund Amount",
  "Refund Currency": "Refund Currency",
  "wheather cancel pick up": "wheather cancel pick up",
  "photo": "photo",
  "Aliexpress code": "Aliexpress code",
  "Agent process status": "Agent process status",
  "DTO": "DTO",
  "customer process time": "customer process time",
  "return day": "Return Days",
  "Inbound manifest": "Inbound manifest",
  "Non Battery": "Non Battery",
  valueServiceInfo: " value-added servic info",
  "Skip quote details": "Skip quote details",
  reuiqre2: '',
  'operation time': 'operation time',
  chargeType: "charge Type",
  'taxationType': 'Taxation Type',
  'WarehouseOutTime': 'Outbound Time',
  'Warehouse Remark': 'Warehouse Remark',
  'SKU Barcode': 'SKU Barcode',
  'Customer service Handler': 'Customer service Handler',
  'endTripBill': 'Last Mile MAWB',
  'Receiving Warehouse CTNS': 'Warehouse Receiving CTNS',
  'Customer forecast CTNS': 'Customer forecast CTNS',
  'Receiving Warehouse quantity': 'Receiving Warehouse quantity',
  'Customer forecast quantity': 'Customer forecast quantity',
  'Shipper Remark': 'Shipper Remark',
  'Tracking number': 'Tracking number',
  'intercept': 'Intercept Order',
  'Update Status Time': 'Update Status Time',
  'Update Status': 'Update Status',
  'Pickup Time': 'Pickup Time',
  'Pickup User': 'Pickup User',
  'pickup': 'Pickup List',
  'Process Info Time': 'Process Info Time',
  'TaxRules': 'Tax Rules',
  ReceiptSignReceipt: "Receipt Sign Receipt",
  High: "High",
  Low: "Low",
  DeliveryMethod: 'Delivery Method',
  Part: 'Part',
  tagService: 'Change Label service',
  shippingMarkLabelReplacedFile: 'Shipping Mark Label Replaced File',
  SKULabelReplacedFile: 'Label Replaced File',
  SKULabelReplacedInfo: 'Label Replaced Info',
  dduShipment: "DDU Shipment",
  tracker_time: 'Tracker Time',
  totalFee: 'Total Fee',
  SettlementAgent: 'Settlement Agent',
  SettlementCustomers: 'Settlement Customers',
  SettlementStatus: 'Settlement Status',
  calculationTime: 'Calculate Time',
  SettlementObject: "Settlement Object",
  Customer: "Customer",
  OutboundRemarks: "Outbound Remarks",
  dduBill: "DDU Bill",
  OriginalFee: "Original Fee",
  TargetSettlementFee: "Target Settlement Fee",
  TotalAmountReceivable: "Total Amount Receivable",
  "Excel Import": "Excel Import",
  "FBA Number": "FBA Number",
  "Upload File": "Upload File",
  "Air Agency Time": "Air Agency Time",
  "Clearance Start Time": "Clearance Start Time",
  "Confirm Upload file": "Confirm Upload file",
  "Old FBA Number": "Old FBA Number",
  "New FBA Number": "New FBA Number",
  "Old SKU": "Old SKU",
  "New SKU": "New SKU",
  "SKU Number": "SKU Number",
  "Cancel Confirm": "Cancel Confirm",
  "Change Target Currency Rate": " Change Target Currency Rate",
  "Old FBA Number": "Old FBA Number",
  "New FBA Number": "FBA Number",
  "Old SKU": "Old SKU",
  "New SKU": "SKU",
  "Batch Upload": "Batch Upload",
  "Storage Charges": "Storage Charges",
  "Number Charges": "Number Charges",
  "Charges Unit": "Charges Unit",
  "Transit Time": "Transit Time",
  "Transit Destination": "Transit Destination",
  "Delivery Time": "Delivery Time",
  "Delivery Type": "Delivery Type",
  "DD Type": "DD Type",
  "all empty": "It can't all be empty",
  "Expense Item": "charge item",
  "Charge Mode": "Charge Mode",
  "Charge Total Amount": "Charge Total Amount",
  "Confirm Freight": "Confirm Freight",
  "Company name": "Company name",
  "Total qyt": "Total qyt",
  "Upload Appointment Number Doc": "Upload Appointment Number Doc",
  "Appointment delivery Date": "Appointment delivery Date",
  "Appointment delivery Time": "Appointment delivery Time",
  "Abnormal Message": "Abnormal Message",
  ReceiptSignReceiptDownload: "Proof of delivery",
  whetherFreight: "Whether Quotation",
  other_fee_bill: "Other Fee Bill",
  offerer: "Offerer",
  QuotationConfirmTime: "Quotation Confirm Time",
  "Old FBN Number": "Old FBN Number",
  "New FBN Number": "FBN Number",
  finished: "finished",
  unfinished: "unfinished",
  "Delivery warehouse": "Delivery warehouse",
  "unconfirmed": "unconfirmed",
  "Whether Outbound": "Whether Outbound",
  "Association Service": "Association Service",
  "customExport": "Custom Export",
  SettlementFee: "Settlement Fee",
  downloadReceipt: "Download Receipt",
  downloadEnclosure: "attachment information",
  waiting: "Waiting",
  refresh: "refresh",
  Area: "Area",
  deliveryWarehouse: "delivery Warehouse",
  messageBoard: 'Message Board',
  other_fee_bill_hq: 'Other Fee Bill',
  edit: 'Edit',
  oldCity: 'Old City',
  oldConsigneeAddress: 'Old Consignee Address',
  TotalVATAmount: 'Total VAT Amount',
  title_cn: 'Cn Title',
  title_en: 'En Title',
  content_cn: 'Cn Content',
  content_en: 'En Content',
  faq: 'Faq',
  TrackAssociation: 'Association Track',
  to_bhd: 'BHD',
  to_omr: 'OMR',
  to_iqd: 'IQD',
  to_ils: 'ILS',
  to_jod: 'JOD',
  WhetherPayFreight: 'Whether Pay Freight',
  UploadFreightAudit: 'Upload Freight Audit',
  TransitionSettlementCurrency: 'Transition Settlement Currency',
  ActualAmountRefund: 'Actual Amount Refund',
  draft: 'Draft',
  FinalActualAmountRefund: 'Final Actual Amount Refund',
  refundCod: 'Refund Cod',
  OtherAccountReceivable: 'Other Account Receivable',
  ConvertedCurrencyObject: 'Converted Currency Object',
  ConvertedCurrency: 'Converted Currency',
  HedgingAmount: 'Hedging Amount',
  fastening: 'Remove Order',
  beijing_time_difference: 'Beijing Time Difference',
  differenceDay: 'Please confirm whether the time is:',
  WhetherBilling: 'Whether Billing',
  quoteDetails: 'Quote Details',
  BillPreview: 'Bill Preview',
  customerCityMapping: 'Customer City Mapping',
  ClientCityName: 'Client City Name',
  evidenceHistory: 'Evidence History',
  evidenceTime: 'Evidence Time',
  evidenceFile: 'Evidence File',
  diff_weight: 'weight differential',
  Body: 'Body',
  overseasInboundTime: 'Overseas Inbound Time',
  'Match old system order': 'Match old system order',
  'Old system order': 'Old system order',
  SupportCod: "Support Cod",
  DeliveryFailReason: "Delivery Fail Reason",
  ReturnDescription: "Return Description",
  'multiplePackageShipment': 'Commercial Express',
  repository: 'knowledge base',
  deliveryPartyForecast: 'Delivery Party Forecast',
  Forecast: 'Forecast',
  'Forecast Result': 'Forecast Result',
  'deliveryAging': 'delivery Aging',
  'operation content': 'Operation Content',
  'detailedAddress': 'Detailed Address',
  halfPriceParams: ' Half Price Params',
  minimum: 'Minimum',
  maximum: 'Maximum',
  specifyAmount: 'Specify Amount',
  quotationName: 'Quotation Name',
  chargeRule: 'Charge Rule',
  freeShipping: 'Free Shipping',
  fixedAmount: 'Fixed Amount',
  TaxesUnitPrice: 'Taxes Unit Price',
  TO_WMS: "To WMS",
  'Weigh more than': 'Weigh more than ',
  labelIsReplacedDoneFile: 'Label Replaced Done File',
  labelIsReplacedDoneFileBatchDownload: 'Label Replaced Done File Batch Download',
  clearance_done_date: "Customs Clearance Done Time",
  Replenish: "Replenish",
  VATRate: "VAT Rate",
  ttParcelForecast: "TT Parcel Forecast",
  declaredWeight: "Declared Weight",
  file_name: "File Name",
  expectPickUpStartTime: "Expect Pick Up Start Time",
  expectPickUpEndTime: "Expect Pick Up End Time",
  VnlinWeight: "Vnlin Weight",
  alreadyInboundQuantity: "Already Inbound Quantity",
  NotInboundQuantity: "Not Inbound Quantity",
  UploadEvidenceFile: "Upload Evidence File",
  UploadlabelIsReplacedDoneFile: "Upload Label Is Replaced Done File",
  childOrderPcs: 'Sub order pcs',
  podSettlement: 'POD Settlement',
  WeightType: 'Weight Type',
  FreightVAT: "Freight VAT",
  channel_english_name: 'Channel English Name',
  versionUpdate: 'System version update alert',
  whetherUpdatePage: 'Whether Update Page?',
  batchDelivery: 'Batch Delivery',
  packetDeliveryCost: 'Packet Delivery Cost',
  PODType: 'POD Type',
  branch_cod_list_new: "Branch Cod List New",
  ModificationCost: "Modification Cost",
  'Threshold Values': 'Threshold Values',
  'Duty Rate': 'Duty Rate',
  'Paper Fee': 'Paper Fee(Ticket)',
  'Clearance Fee': 'Clearance Fee(Ticket)',
  'Billing Weight': 'Billing Weight',
  'tracking order': 'tracking order',
  'Arrived delivery Hub': ' Arrived delivery Hub',
  'Arrived delivery Hub Rate': ' Arrived delivery Hub Rate',
  'Pending delivery': 'Pending delivery',
  'Pending delivery rate': 'Pending delivery rate',
  'USD To Destination Currency Rate': 'USD To Destination Currency Rate',
  'auto bind': 'auto bind',
  'Total Quantity': 'Total Quantity',
  'Total Ctns': 'Total Ctns',
  'Pening outbound': 'Pening outbound',
  'wheather finished outbound': 'wheather finished outbound',
  'MAWB NO.': 'MAWB NO.',
  'WAbnormal': 'abnormal',
  'abnormal bills': 'abnormal bills',
  'warehouse remark': 'warehouse remark',
  'finish time': 'finish time',
  'Delivery Fail Params': 'Delivery Fail Params',
  'Set Label': 'Set Label',
  'DeliveryMode': 'Delivery Mode',
  'Fold': '% OFF',
  'no discount': 'no discount',
  'Assign SMSA': 'Assign SMSA',
  'Assign JT': 'Assign JT',
  'Assign Smile': 'Assign iMile',
  'AssignAgent': 'Assign Agent Name',
  Battery: 'Battery',
  uploading: 'uploading',
  uploadFail: 'upload Fail',
  batchBind: 'batch Bind',
  'search criteria cannot be empty': 'search criteria cannot be empty',
  'PCS Count': 'PCS Count',
  'Document Cameras': 'Document Cameras',
  'Start uploading': 'Start uploading',
  'gather': 'gather',
  'gatherSuccess': 'Gather Success',
  'Imprest': 'Imprest',
  'applyImprest ': 'Apply Imprest',
  'applyTitle': 'Apply Title',
  'applyReason': 'Apply Reason',
  'applyAmount': 'Apply Amount',
  'proposer': 'Proposer',
  'applyDepartment': 'Apply Department',
  exportRecords: "Export Records",
  ElapsedTime: "Elapsed Time",
  ImprestBalance: "Imprest Balance",
  QuotationRemarks: "Quotation Remarks",
  vatFee: "VAT Fee",
  miscellaneousQuotation: 'Miscellaneous Quotation',
  quotationStatus: 'Quotation Status',
  quotationTime: 'Quotation Time',
  AlreadyQuotation: 'Already Quotation',
  notQuotation: 'not Quotation',
  Created: 'Created',
  notCreated: 'not Created',
  reimburseStatement: 'Reimburse Statement',
  vatBill: 'VAT Bill',
  circuit: 'Circuit',
  systemDeliveryParty: 'System Delivery Party',
  LabelWatermark: 'Label Watermark',
  aterialIntercept: 'Aterial Intercept',
  InterceptRemarks: 'Intercept Remarks',
  DestinationCity: 'Destination City',
  "Revise Transport Mode": "Revise Transport Mode",
  "Fixed USD": "Fixed USD",
  "Destination Currency": "Destination Currency",
  "Administration fee": "Administration fee",
  "Declared Currency Type": "Declared Currency Type",
  storageBill: "Storage Bill",
  billingStartTime: "Billing Start Time",
  billingEndTime: "Billing End Time",
  ECommerce: "E-commerce",
  printLabel: 'Print Label',
  startPrint: 'Start Print',
  SystemDefault: 'System Default',
  pushTMS: 'Push TMS',
  branch_storage_fee: 'Storage Fee',
  branch_storage_bill: 'Branch Storage Bill',
  AgentDeliveryAllowed: 'Agent Delivery Allowed',
  'master bill number': "Tracking Number",
  'child  bill number': "Sub order",
  'Order channel': "Order channel",
  'service remark': "service remark",
  'branch_other_fee': "Other Fee",
  'rejection_boxno': "Rejection Boxno",
  'tt_track': 'TT Tracker',
  'Tracker Status': 'Tracker Status',
  'Tracker ID': 'Tracker ID',
  'Occurred Time': 'Occurred Time',
  'Input Time': 'Input Time',
  'input channel': 'input channel',
  'Push Error Count': 'Error Count',
  'Start Push Time': 'Start Push Time',
  'Push Status Time': 'Push Status Time',
  'Push Status': 'Push Status',
  'Synchronizing': 'Synchronizing',
  'Manual Intervention': 'Manual Intervention',
  other_fee_hq_new: 'New Other Fee Hq',
  'Finance of Guangzhou Hq (Freight: small bag)': 'Finance of Guangzhou Hq (Freight: small bag)',
  'Finance of Guangzhou Hq (Freight: Shuangqing)': 'Finance of Guangzhou Hq (Freight: Shuangqing)',
  'Finance of Guangzhou Hq (COD)': 'Finance of Guangzhou Hq (COD)',
  BillingInterval: "Billing Interval",
  'Push duration': "Push duration",
  'batch update PLInvoice': 'Upload file (PL ,Invoice)',
  'Branch financial supervisor': 'Branch financial supervisor',
  'Branch financial accountant': 'Branch financial accountant',
  'Discounts Setting': 'Discounts Setting',
  'deadline': 'Deadline',
  'deadlineDay': 'Deadline Day',
  'Duration Time': 'Duration Time',
  'Intercept Count': 'Intercept Count',
  'data sources': 'Data Sources',
  'individual traveler': 'individual traveler',
  'clientConfig': 'Client Config',
  userInfoStr2: "Track push callback url",
  userInfoStr3: "Track rollback callback url",
  authorization: "Authorization",
  WhetherAlreadyOperation: "Whether Already Operation",
  halfPriceSetting: 'Half Price Setting',
  SyncOrderTemplate: 'Sync Order Template',
  BillingMethod: 'Billing Method',
  freightRata: 'Freight rata',
  'Fixed amount per ticket': 'Fixed amount per ticket',
  'POD Time': 'POD Time',
  'Fixed amount currency per ticket': 'Fixed amount currency per ticket',
  'Reimbursement type': 'Reimbursement type',
  'bank deposit': 'bank deposit',
  'Reimbursement slip number': 'Reimbursement slip number',
  'Reimbursement type': 'Reimbursement type',
  'Cost details': 'Cost details',
  'Reasons for reimbursement': 'Reasons for reimbursement',
  'Currency of application': 'Currency of application',
  'System notification phone': 'System notification phone',
  'Bagging failure reasons': 'Bagging failure reasons',
  'error of replication': 'error of replication',
  otherQuotation: 'Other Quotation',
  RuleDetails: 'Rule Details',
  'Customer quotation rule': 'Customer quotation rule',
  'Charging remarks': 'Charging remarks',
  'formula mode': 'formula mode',
  "special_claim": " Special Claim",
  "Follow up customer service": "Follow up customer service",
  "Freight currency": "Freight currency",
  "Freight amount": "freight amount",
  "Scheme amount": "Scheme amount",
  "Scheme Scheme": "Scheme Scheme",
  "Transfer Order": "Transfer Order",
  "Total bag count": "Total bag count",
  "Whether enter weight information": "Whether enter weight information",
  "Shelf days": "Shelf days",
  "System Inform Email": "System Inform Email",
  "transfernew": "New transfer order",
  "Whether Unpack": "allow inspection or not",
  "Personal information not bound warehouse": "Personal information not bound warehouse",
  "transportAirport": "TransportAirport",
  "Arrival track": "Arrival track",
  "Outgoing track": "Outgoing track",
  "money receiving QR code": "money receiving QR code",
  "TT take down instruction": "TT take down instruction",
  "Take down instruction date": "Take down instruction date",
  'unboxList': 'Open Package Inspection list',
  "smsList": "SMS list",
  "smsContent": "Sms Content",
  "Send Time": "Send Time",
  "Send Status": "Send Status",
  'whether Unpack': 'allow inspection or not',
  'Operation fee charging mode': 'Operation fee charging mode',
  'Registration link': 'Registration link',
  'podBill': 'Overseas Special POD Bill',
  addHistory: "On/Off Shelf Record",
  'setting Unpack': "Setting allow open",
  orderTrack: "Order Track",
  Create: "Create",
  task: "Task",
  unblock: "Unblock",
  LabelMiniNoInvoice: "Label(100*100 No Invoice)",
  printing: "Printing",
  printingTip: "When the amount of data is large, please wait patiently, do not operate other!",
  clearance_end_date: "Customs Clearance Finish Date",
  scanInboundDate: "Scan Inbound Date",
  'Source name': "Source name",
  'balance': "Balance",
  'dduRule': "DDU Rule",
  'error create order': 'error create order',
  'warehouse receive number': 'warehouse receive number',
  'Verification method': 'Verification method',
  'Offline verification': 'Offline verification',
  'Online verification': 'Online verification',
  'Reimbursement method': 'Reimbursement method',
  'Reimbursement time': 'Reimbursement time',
  'Delivery Sheet': 'Delivery Sheet',
  'b2BToB2COrder': 'B2B To B2C Order',
  'createB2BToB2C': 'Create B2B To B2C',
  collectingMoney: "COD",
  numberParcels: "Package Number",
  clientCompany: "Company",
  shipperName: "Receiver Name",
  Email: "Email",
  order_address: "Address",
  'Product Name': "Product Name",
  'Gross Weight': "Gross Weight",
  'SKU Barcode': "SKU Barcode",
  order_goods: "Product quantity",
  cityArea: 'cityArea',
  cityCircuit: 'City Circuit',
  cityAlias: 'City Alias',
  First: 'First',
  'Total charged weight': 'Total charged weight',
  'Internal audit comments': ' Internal audit comments',
  'Push customer comments': ' Push customer comments',
  'Completed': 'Completed',
  'Collect warehouse fees': 'Collect warehouse fees',
  'board_number': 'Board Number',
  'Alipay order number': 'Alipay order number',
  'Associated Order': 'Associated Order',
  'deliveryCostQuoteRule': 'Delivery Cost Quote Rule',
  'Step': 'Step',
  'podRollback': 'Pod Rollback',
  'trackRollback': 'trackRollback',
  'Location': 'Location',
  'Delivery Driver Phone': 'Delivery Driver Phone',
  clearanceCostQuoteRule: 'Clearance Cost Quote Rule',
  'Trailer fee': 'Trailer fee',
  b2bCostQuoteRule: 'B2B Cost Quote Rule',
  'no order': 'No Order',
  storageCostQuoteRule: 'Storage Cost Quote Rule',
  'Display shipper': 'Display shipper',
  storageOperateQuoteRule: 'Storage Operate Quote Rule',
  BigBag: 'Big Bag',
  dataBoard: 'Data Board',
  Evidence: 'Evidence',
  'Expired quotation': 'Expired quotation',
  'Expiring soon quotation': '{1} Day Expiring soon quotation',
  lingyang: 'LING YANG Subcontracting',
  Arrive: 'Arrive',
  arrive: 'Arrive',
  Total1: 'Total',
  endTrip1: 'endTrip',
  storageFeeQuoteRule: 'Storage Fee Quote Rule',
  'WAIT': 'Waiting for delivery',
  'TAIL': 'Received',
  'POD': 'Completed',
  'BoardCargo': 'Board Cargo',
  'unblockIntercept': 'TMS unblock intercept',
  'fordelQuoteRule': 'B2B Auto Quote Rule',
  'transportFee': 'Transport Fee',
  'groceries': 'Groceries',
  'Unloading fee': 'Unloading Fee',
  'Combine Packages Fee': 'Combine Packages Fee',
  'Load Cabinet': 'Load Cabinet',
  'Last update time': 'Last update time',
  'Sales team': 'Sales team',
  '@Phones': "@ Member's phone number",
  'Expense subject': 'Expense subject',
  'Please complete the form': 'Please complete the form',
  'printer': 'Printer',
  'doorToDoor': 'Door to door service',
  'Remote degree': 'Remote degree',
  'emergencyKit': 'Emergency Kit',
  'tmsInbound': 'TMS Inbound',
  'accurate': 'Accurate',
  'password': 'Password',
  'Pending callback': 'Pending callback',
  'Waybill': 'Waybill',
  'output_port': 'Output Port',
  'SA': 'SA',
  'AE': 'AE',
  'changeOrderList': 'Change Order List',
  'New order number': 'New order number',
  'Service fees': 'Service fees',
  'Label change': 'Label Change',
  'Tip': 'Tip',
  'Channel': 'Channel',
  'Site': 'Site',
  'Warehousing': 'Warehousing',
  'In warehouse': 'In warehouse',
  'Total volume': 'Total volume',
  'Carton': 'Carton',
  'Mixed': 'Mixed',
  'High tax types': 'High tax types',
  'High tax and fee billing rules': 'High tax and fee billing rules',
  'Minimum tax collection point': 'Minimum tax collection point',
  'MANIFEST FEE Types': 'MANIFEST FEE Types',
  'MANIFEST FEE Calculation Rules': 'MANIFEST FEE Calculation Rules',
  commissionManagement: 'Commission Management',
  businessCommissionConfig: 'Business Commission Config',
  'Valid period': 'Valid period',
  'International': 'International',
  'Local': 'Local',
  'China to Israel': 'China to Israel',
  'Customs clearance': 'Customs clearance',
  'Profit ratio': 'Profit ratio',
  'Team Management': 'Team Management',
  commissionDetails: 'Commission Details',
  'Commission': 'Commission',
  'Middle East': 'Middle East',
  'Israel': 'Israel',
  'Manage': 'Manage',
  'whole course': 'Whole course',
  'Whole board': 'Whole board',
  'Pending Billing': 'Waiting for billing',
  'storageFeeNew': 'Location details new',
  'locationDetailsNew': 'Location details new',
  'detail data': 'detail data',
  'segmentDetails': 'Segment Details',
  'Tax': 'Tax',
  'overseasHolidays': 'Overseas Holidays',
  'Holidays': 'Holidays',
  'Detection': 'Detection',
  'Today': 'Today',
  'Monday': 'Monday',
  'Tuesday': 'Tuesday',
  'Wednesday': 'Wednesday',
  'Thursday': 'Thursday',
  'Friday': 'Friday',
  'Saturday': 'Saturday',
  'Sunday': 'Sunday',
  'inboundNotBagged': 'Inbound Not Bagged',
  'segmentBill': 'Segment Bill',
  'workOrderManagement': 'Work Order Management',
  'workOrderType': 'Work Order Type',
  'Work Order': 'Work Order',
  'Reply': 'Reply',
  'Parent': 'Parent',
  'Shipping Order Number': 'Shipping Order Number',
  'workOrderList': 'Work Order List',
  'Collect': 'Collect',
  'Collectors': 'Collectors',
  'ttPackageCollection': 'TT Package Collection',
  'Work order number': 'Work order number',
  'Regional zoning': 'Regional zoning',
  'Not partitioned': 'Not partitioned',
  'Payment': 'Payment',
  'Please search for a country before proceeding': 'Please search for a country before proceeding',
  'Urban zoning': 'Urban zoning',
  'partition': 'Partition',
  'Package': 'Package',
  'tm_track': 'TM Track',
  'No charge': 'No charge',
  'abnormalArrivalTrajectory': 'Abnormal Arrival Trajectory',
  gccOrderStatistics: 'GCC Order Statistics',
  'Platform Product Info': 'Platform Product Info',
  'goodsIdPlaceholder': 'Product ID is a pure number of 11 or 16 digits',
  'closed loop': 'Closed Loop',
  'Picking1': 'Picking',
  'for short': 'For Short',
  frequency: 'Frequency',
  Transfer: 'Transfer',
  tmClosedLoop: 'TM Closed Loop',
  latest: 'Latest',
  MainStatus: 'Main Status',
  trackerMainStatus: 'Tracker Main Status',
  Limit: 'Limit',
  Billing1: 'Billing',
  'material': 'Material',
  'Recorded': 'Recorded',
  'With or Without': 'With or Without',
  'billingRecord': 'Billing Record',
  'Please enter the local time': 'Please enter the local time',
  Single1: 'Single',
  Bank1: 'Bank',
  previously: 'Previously',
  riskControl_new: 'RiskControl New',
  'manual rec': 'Manual Rec',
  deliveryStatistics: 'Delivery Statistics',
  b2borderStatistics: 'B2B Order Statistics',
  proportion: 'Proportion',
  customerClearanceEndTripBill: 'Customer Clearance End Trip Bill',
  History: 'History',
  'AFR Intern': 'AFR Intern',
  'Platform Group': 'Platform Group',
  'operating': 'Operating',
  'offerBill': 'Offer Bill',
  'Delivered': 'Delivered',
  'Residue': 'Residue',
  'Total2': 'Total',
  'Temporary Duration': 'Temporary duration',
  'temporaryStorageOverseas': 'Temporary Storage Overseas',
  'exportManager': 'Export Manager',
  'isolation': 'Isolation',
  'Overrun': 'Overrun',
  overseasShelve: 'Overseas Shelve',
  'skuPcs': 'PCS',
  'Operate Time': 'Operate Time',
  'Complete Time': 'Complete Time',
  'Async': 'Async',
  'Pre': 'Pre',
  adjustBillRecord: 'Adjust Bill Record',
  detail3: 'Detail',
  orderTimeoutInspection: 'Order Timeout Inspection',
  Inspection: 'Inspection',
  'Combined display': 'Combined display',
  'contractTitleAndAgreement': 'Contract Title And Agreement',
  'Alipay Pay': 'Alipay Pay',
  'WeChat Pay': 'WeChat Pay',
  'otsCityMapping': 'OTS City Mapping',
  'Clearance delivery bill': 'Clearance delivery bill',
  'missingTrackMonitor': 'Missing Track Monitor',
  'missing': 'Missing',
  'Complete section': 'Complete Section',
  'Clearance delivery': 'Clearance Delivery',
  'Concern Extent': 'Concern Extent',
  'billFirstAnalysis': 'Bill First Analysis',
  'Arrive': 'Arrive',
  'Prefix': 'Prefix',
  'Airline': 'Airline',
  'financialRevenue': 'Financial Revenue',
  'Order Quantity': 'Order Quantity',
  'Affiliation': 'Affiliation',
  'Shipment': 'Shipment',
  'gross profit': 'Gross Profit',
  'gross profit rate': 'Gross Profit Rate',
  'Average': 'Average',
  'Trace': 'Trace',
  'timeoutOrder': 'Timeout Order',
  tmTrackWarning: 'TM Track Warning',
  Coefficient: 'Coefficient',
  Ultimately: 'Ultimately',
  DifferenceRate: 'Difference Rate',
  'TEMU CCD TO FIRST': 'TEMU CCD TO FIRST',
  Dendrogram: 'Dendrogram',
  'Ranking List': 'Ranking List',
  'Rank': 'Rank',
  'Display': 'Display',
  'Ranking': 'Ranking',
  'Transit Port Order': 'Transit Port Order',
  'Harbour Mark': 'Harbour Mark',
  analysisReturnException: 'Analysis Return Exception',
  agentExceptionList: 'Agent Exception List',
  'Default payment': 'Default payment',
  'Re-audit after N days': 'Re-audit after N days',
  'Please go to Export management download': 'Please go to Export management download',
  ttForecastInfo: 'TT Forecast Info',
  'Small charged mark': 'Small Charged Mark',
  timeoutOrderStatistics: 'Timeout Order Statistics',
  level: 'Level',
  Settlement: 'Settlement',
  cityParition: 'Level ID',
  'fs_name': 'Goods Remarks',
  percents: 'P-Percent',
  allowCategory: 'Accept Goods Type',
  b2bCosting: 'B2B Costing Rule',
  b2bDeliver: 'B2B Delivery Fee Costing Rule',
  b2bSalesmanBill: 'B2B Salesman Bill',
  shipment_costing: 'Small Package Costing',
  dduTracker: 'Tracker Sync',
  pushECO: 'Push ECO (B2B)',
  doubleSummary: 'B2B Summary',
  shipment_hq_costing: '小包出货明细（销售）'
};
